
import { DebugPerformanceRow } from "./DebugPerformanceRow";
import { TextStyleOptions } from "../../../../setting/text/IText";
import { FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { DebugTabData } from "../DebugMenuButton";
import { Helper } from "../../../../utils/Helper";
import { MathHelper } from "../../../../utils/MathHelper";
import { TimeCheckPoints } from "../../../../utils/TimeCheckPoints";
import {  gsap } from "gsap";

export enum DebugPerformanceType{
    FPS = "FPS",
    AVERAGE_FPS = "AVERAGE_FPS",
    NR_OBJECTS = "NR_OBJECTS",
    NR_RENDERED_OBJECTS = "NR_RENDERED_OBJECTS",
    NR_MASKS = "NR_MASKS"
}

export class DebugPerformance extends PIXI.Container implements DebugTabData {

    private text:PIXI.Text;
    private rows:DebugPerformanceRow[] = [];
    private checkPointName:string = "Performance";

    private DEFAULT_TEXT_STYLE:TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 10,
        dropShadowDistance: 2,
        fontFamily : "Helvetica",
        fontWeight : FontWeight.BOLD,
        fontSize: 28,
        align:"left",
        wordWrap: true,
        wordWrapWidth: 400,
        fill: [
            "white",
        ]
    };

    private tl:gsap.core.Timeline;

    constructor(){
        super();
        this.init();
        this.visible = false;
    }
    public get activated():boolean{
        return this.visible;
    }

    public init():void {
        this.text = this.addChild(new PIXI.Text("Performance", this.DEFAULT_TEXT_STYLE));
        // this.interactive = true;
        this.position.set(115,-155);
    }

    public toggle():void{
        this.visible = !this.visible;
        if(this.visible) this.createRows();
        this.activateLoop();
    }

    private activateLoop():void{
        this.tl = Helper.setTimeline(this.tl,new gsap.core.Timeline({
            onUpdate:() => { if(this.visible) this.updateRows(); },
            repeat: this.visible ? -1 : 0
        }))

        if(this.visible){
            TimeCheckPoints.setCheckPoint(this.checkPointName);
            this.tl.to(this,{duration:1});
        }else{
            TimeCheckPoints.removeCheckPoint(this.checkPointName);
        }
    }

    private updateRows():void{
        this.rows.forEach(r => { r.onUpdate(TimeCheckPoints.getCheckPointTime(this.checkPointName)); });
    }

    private createRows():void {
        if(this.rows.length) return;

        const typeList:string[] = Object.keys(DebugPerformanceType);

        for(let l:number = 0; l < typeList.length; l++){
            this.rows.push(this.addChild(new DebugPerformanceRow(typeList[l])));
            this.rows[l].setRowID(l);
            this.rows[l].position.y = l == 0 ? 0 : this.rows[l-1].position.y + this.rows[l-1].height;
            // this.rows[l].position.y = l == 0 ? 50 : this.rows[l-1].position.y + this.rows[l-1].height;
        }
    }

    public hide():void{
        this.visible = false;
    }
}